import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import useApiContext from 'hooks/useApiContext';

/**
 * bbmatch (matchmaking) shown inside Exhibitors Manager, already logged in:
 * EM asks its API for a signed link (valid one minute, single use) and opens
 * it in a frame with embed=1, so bbmatch hides its own header.
 * - /events/:eventId/matchmaking: the event's matchmaking (event menu on
 *   the left, like the ticketing);
 * - /matchmaking: bbmatch's home for the user (ultra admin space for the
 *   super admin, organiser space for admins and moderators).
 */
export default function Matchmaking(): JSX.Element {
  const { eventId } = useParams();
  const { ticketingRepository } = useApiContext();
  const [src, setSrc] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setSrc(null);
    setError(null);
    const request = eventId
      ? ticketingRepository.getMatchmakingLink(eventId)
      : ticketingRepository.getMatchmakingHomeLink();
    request
      .then((r) => setSrc(`${r.url}${r.url.includes('?') ? '&' : '?'}embed=1`))
      .catch((e: Error) => setError(e.message));
  }, [eventId]);

  if (error) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography sx={{ color: '#b91c1c' }}>{error}</Typography>
      </Box>
    );
  }
  if (!src) {
    return (
      <Box sx={{ p: 6, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  return (
    <iframe
      key={src}
      title="Matchmaking"
      src={src}
      style={{
        display: 'block',
        width: '100%',
        minHeight: 'calc(100vh - 71px)',
        border: 0,
        background: '#f9fafb',
      }}
      allow="clipboard-write"
    />
  );
}
